import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@core/http-legacy';
import type { OfferLanguageItem, OfferLanguagesSetup } from '@core/offers-types';

@Injectable({
  providedIn: 'root',
})
export class OfferLanguagesHttpService {
  private readonly httpApi = inject(HttpApiService);

  public fetchOne$(id: number): Observable<{ offerId: number; setup: OfferLanguagesSetup }> {
    return this.httpApi.get(`/offers/${id}/languages`).pipe(
      map(response => ({
        offerId: id,
        setup: response,
      })),
    );
  }

  public toggleLanguageItem$(props: {
    offerId: number;
    code: string;
    enabled: boolean;
  }): Observable<OfferLanguageItem> {
    return this.httpApi.patch(`/offers/${props.offerId}/languages/${props.code}`, null, {
      language: { enabled: props.enabled },
    });
  }

  public setPrimaryLanguage$(props: {
    offerId: number;
    code: string;
  }): Observable<OfferLanguageItem> {
    return this.httpApi.patch(`/offers/${props.offerId}/languages/${props.code}`, null, {
      language: { make_primary: true },
    });
  }
}
